import React, { useEffect, useState } from 'react';
import UserAgreementDocument from '../components/UserAgreementDocument';
import { API_URL } from '../config';
import { DEFAULT_USER_AGREEMENT_DOCUMENT } from '../legal/userAgreement';
import { safeFetch } from '../utils/safeFetch';

const UserAgreement = () => {
  const [agreement, setAgreement] = useState(DEFAULT_USER_AGREEMENT_DOCUMENT);

  useEffect(() => {
    let disposed = false;

    const loadAgreement = async () => {
      try {
        const document = await safeFetch(`${API_URL}/api/user-agreement`, {}, 12000);
        if (!disposed) {
          setAgreement(document);
        }
      } catch (error) {
        console.warn('Не удалось загрузить пользовательское соглашение:', error);
      }
    };

    loadAgreement();
    return () => {
      disposed = true;
    };
  }, []);

  return (
    <div className="mx-auto max-w-5xl">
      <UserAgreementDocument agreement={agreement} />
    </div>
  );
};

export default UserAgreement;
